/* © ИП Коробкин И.Н., KIN DIGITAL CRM+ */
import { CourtCaseCardPage, CourtCasesPage } from './pages/CourtCases';
import { MonitoringPage } from './pages/Monitoring';
import { AutomationsPage } from './pages/Automations';
import { FormsPage } from './pages/Forms';
import { EzpPage } from './pages/Ezp';
import { HelpArticlePage, HelpPage } from './pages/Help';
import { PublicFormPage } from './pages/PublicForm';
import { PublicSignPage } from './pages/PublicSign';
import { PortalLoginPage, PortalPage } from './pages/Portal';
import { AboutPage } from './pages/About';
import { AiPolicyPage } from './pages/admin/AiPolicy';
import { PracticePage } from './pages/Practice';
import { MobileAppPage } from './pages/MobileApp';
import { StaffMobilePage } from './pages/StaffMobile';
import { CollectionPage } from './pages/Collection';
import { AgentPage } from './pages/Agent';
import { BotPage } from './pages/Bot';
import { SmsPage } from './pages/Sms';
import { CallsPage } from './pages/Calls';
import { InboxPage } from './pages/Inbox';
import { AppOrdersPage } from './pages/AppOrders';
import { BrandingPage } from './pages/admin/Branding';

import { BiPage } from './pages/Bi';
import { ForceChangePasswordPage } from './pages/ForceChangePassword';
import { SmartSearchPage } from './pages/SmartSearch';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Spinner } from './components/ui';
import { useAuth } from './lib/auth';
import { LoginPage } from './pages/Login';
import { DashboardPage } from './pages/Dashboard';
import { PartiesPage } from './pages/Parties';
import { PartyCardPage } from './pages/PartyCard';
import { DealsPage } from './pages/Deals';
import { ContractsPage } from './pages/Contracts';
import { ContractCardPage } from './pages/ContractCard';
import { MattersPage } from './pages/Matters';
import { MatterCardPage } from './pages/MatterCard';
import { TasksPage } from './pages/Tasks';
import { CalendarPage } from './pages/Calendar';
import { DocumentsPage } from './pages/Documents';
import { ExpensesPage } from './pages/Expenses';
import { UsersPage } from './pages/admin/Users';
import { DictionariesPage } from './pages/admin/Dictionaries';
import { LicensePage } from './pages/admin/License';
import { AuditPage } from './pages/admin/Audit';
import { ProfilePage } from './pages/Profile';
import { DeadlinesPage } from './pages/Deadlines';
import { DebtsPage } from './pages/Debts';
import { DebtCardPage } from './pages/DebtCard';
import { BankruptcyPage } from './pages/Bankruptcy';
import { ProcedureCardPage } from './pages/ProcedureCard';
import { AuctionsPage } from './pages/Auctions';
import { WritsPage } from './pages/Writs';
import { TimePage } from './pages/Time';
import { TemplatesPage } from './pages/admin/Templates';
import { AssistantPage } from './pages/Assistant';

export function App() {
  const { me, loading, can } = useAuth();
  const pub = location.pathname.match(/^\/f\/([a-z0-9-]+)\/?$/);
  if (pub) return <PublicFormPage slug={pub[1]} />;
  const sign = location.pathname.match(/^\/s\/([A-Za-z0-9_-]+)\/?$/);
  if (sign) return <PublicSignPage token={sign[1]} />;
  const plink = location.pathname.match(/^\/p\/([A-Za-z0-9_-]+)\/?$/);
  if (plink) return <PortalLoginPage link={plink[1]} />;
  if (location.pathname === '/portal') return <PortalPage />;
  if (location.pathname === '/app' || location.pathname.startsWith('/app/')) return <MobileAppPage />;
  if (loading) return <Spinner />;
  if (me?.mustChangePassword) return <ForceChangePasswordPage />;
  if (!me) return <LoginPage />;
  if (location.pathname === '/m' || location.pathname.startsWith('/m/')) return <StaffMobilePage />;
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={can('report.read') ? <DashboardPage /> : <Navigate to="/tasks" replace />} />
        <Route path="parties" element={<PartiesPage />} />
        <Route path="parties/:id" element={<PartyCardPage />} />
        <Route path="deals" element={<DealsPage />} />
        <Route path="contracts" element={<ContractsPage />} />
        <Route path="contracts/:id" element={<ContractCardPage />} />
        <Route path="matters" element={<MattersPage />} />
        <Route path="matters/:id" element={<MatterCardPage />} />
        <Route path="tasks" element={<TasksPage />} />
        <Route path="calendar" element={<CalendarPage />} />
        <Route path="documents" element={<DocumentsPage />} />
        <Route path="expenses" element={<ExpensesPage />} />
        <Route path="deadlines" element={<DeadlinesPage />} />
        <Route path="debts" element={<DebtsPage />} />
        <Route path="debts/:id" element={<DebtCardPage />} />
        <Route path="bankruptcy" element={<BankruptcyPage />} />
        <Route path="bankruptcy/:id" element={<ProcedureCardPage />} />
        <Route path="auctions" element={<AuctionsPage />} />
        <Route path="writs" element={<WritsPage />} />
        <Route path="court-cases" element={<CourtCasesPage />} />
        <Route path="court-cases/:id" element={<CourtCaseCardPage />} />
        <Route path="monitoring" element={<MonitoringPage />} />
        <Route path="automations" element={<AutomationsPage />} />
        <Route path="forms" element={<FormsPage />} />
        <Route path="ezp" element={<EzpPage />} />
        <Route path="help" element={<HelpPage />} />
        <Route path="help/:id" element={<HelpArticlePage />} />
        <Route path="time" element={<TimePage />} />
        <Route path="assistant" element={<AssistantPage />} />
        <Route path="admin/templates" element={<TemplatesPage />} />
        <Route path="admin/users" element={<UsersPage />} />
        <Route path="admin/dictionaries" element={<DictionariesPage />} />
        <Route path="admin/license" element={<LicensePage />} />
        <Route path="admin/audit" element={<AuditPage />} />
        <Route path="admin/ai" element={<AiPolicyPage />} />
        <Route path="admin/branding" element={<BrandingPage />} />
        <Route path="practice" element={<PracticePage />} />
        <Route path="collection" element={<CollectionPage />} />
        <Route path="agent" element={<AgentPage />} />
        <Route path="bot" element={<BotPage />} />
        <Route path="sms" element={<SmsPage />} />
        <Route path="calls" element={<CallsPage />} />
        <Route path="inbox" element={<InboxPage />} />
        <Route path="app-orders" element={<AppOrdersPage />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="bi" element={<BiPage />} />
        <Route path="search" element={<SmartSearchPage />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
